/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
import { Button } from 'react-bootstrap';
import cancelIcon from '../../assets/images/Icon-cancel.png';
import { PaperComponent } from '../utilities/utilities';

function ModalDialog({
  open,
  dialogTitle,
  grid,
  cancelAction,
  OkAction,
  closeModal,
  fullWidth,
}) {
  return (
    <div>
      <Dialog
        className="table-dialog-popup dialogPanel custom-check custom-dialog dialog-900"
        open={open}
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            cancelAction(true);
          }
        }}
        fullWidth={fullWidth}
        aria-describedby="modal-description"
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
          <DialogTitle
            className="copy-contact-title"
            style={{ cursor: 'move' }}
            id="draggable-dialog-title"
          >
            <div className="float-left dialog-heading-txt mt-1">
              {dialogTitle}
            </div>
            <div
              className="close-popup-icon float-right"
              role="button"
              onClick={() => closeModal(false)}
            >
              <img alt="" src={cancelIcon} />
            </div>
          </DialogTitle>
          <DialogContent style={{ overflow: 'hidden' }} id="modal-description">
            <div className="mui-custom-form">
              <DialogContentText>{grid}</DialogContentText>
            </div>
          </DialogContent>

          <DialogActions>
            {OkAction ? (
              <Button color="primary" onClick={() => OkAction(false)}>
                Ok
              </Button>
            ) : null}
            <Button color="primary" onClick={() => cancelAction(false)}>
              Cancel
            </Button>
          </DialogActions>
      </Dialog>
    </div>
  );
}

export default ModalDialog;
